import { GET_GIFT_LIST_GUEST_VIEW, GET_GIFT_LIST_GUEST_VIEW_SUCCESS, GET_GIFT_LIST_GUEST_VIEW_FAIL, SET_GIFTEE_NAME,
ADD_ITEM_TO_CART, ADD_ITEM_TO_CART_SUCCESS, ADD_ITEM_TO_CART_FAIL, ADD_ITEM_TO_EXPRESS_CART, ADD_ITEM_TO_EXPRESS_CART_SUCCESS,
ADD_ITEM_TO_EXPRESS_CART_FAIL, } from './actions';

const initialState = {
  loaded: false,
  editing: {},
  saveError: {},
  data: [], 
  addToCartSuccess: false,
  addToCartError: null,
  addToCartResponse: null,
  extraData: {},
  isExpressAdding: false,
  expressCheckoutSuccess: false,
  expressCheckoutError: null,
  expressCheckoutResponse: null,
  gifteeName: '',
};

export default function GiftList(state = initialState, action = {}) {
  switch (action.type) {
    case GET_GIFT_LIST_GUEST_VIEW:
      return {
        ...state,
        loading: true,
      };
    case GET_GIFT_LIST_GUEST_VIEW_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: action.result,
        error: null,
        extraData: 'This is extra info..........',
      };
    case GET_GIFT_LIST_GUEST_VIEW_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: [],
        error: action.error,
      };
    case ADD_ITEM_TO_CART:
      return {
        ...state,
        loading: true,
        isAdding: true,
        addToCartSuccess: false,
        addToCartError: null,
      };
    case ADD_ITEM_TO_CART_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        isAdding: false,
        addToCartSuccess: true,
        addToCartResponse: action.result || {},
        extraData: 'This is extra info..........',
      };
    case ADD_ITEM_TO_CART_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error,
        isAdding: false,
        addToCartSuccess: false,
        addToCartError: typeof action.error === 'string'
            ? action.error
            : action.error?.errorMessage ||
              action.error?.message ||
              'Something went wrong with add to cart',
      };
    case ADD_ITEM_TO_EXPRESS_CART:
      return {
        ...state,
        loading: true,
        isExpressAdding: true,
        expressCheckoutSuccess: false,
        expressCheckoutError: null,
      };

    case ADD_ITEM_TO_EXPRESS_CART_SUCCESS:
      return {
        ...state,
        loading: false,
        isExpressAdding: false,
        expressCheckoutSuccess: true,
        expressCheckoutResponse: action.result || {},
      };

    case ADD_ITEM_TO_EXPRESS_CART_FAIL:
      return {
        ...state,
        loading: false,
        isExpressAdding: false,
        expressCheckoutSuccess: false,
        expressCheckoutError:
          typeof action.error === 'string'
            ? action.error
            : action.error?.errorMessage ||
              action.error?.message ||
              'Something went wrong with express checkout',
      };
    case SET_GIFTEE_NAME:
      return {
        ...state,
        gifteeName: action.data,
      };
    default:
      return state;
  }
}

